import { render, staticRenderFns } from "./Introduce.vue?vue&type=template&id=208717b6&scoped=true&"
import script from "./Introduce.vue?vue&type=script&lang=js&"
export * from "./Introduce.vue?vue&type=script&lang=js&"
import style0 from "./Introduce.vue?vue&type=style&index=0&id=208717b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208717b6",
  null
  
)

export default component.exports